export default __webpack_public_path__ + "static/media/13_mobility_flows.604ef3b6.webp";